import { Group } from "#shared/view/components/Group";
import { Modal } from "#shared/view/components/Modal";
import { Button } from "#shared/view/designSystem/Button";

import { CustomInputsDto } from "../useCustomInputs";
import { CustomInputsList } from "./CustomInputsList";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  quoteRequestLineId: string | undefined;
  isPredicting: boolean;
  customInputs: CustomInputsDto;
  onSubmit: () => void;
};

export const CustomInputsModal = ({
  isOpen,
  onClose,
  quoteRequestLineId,
  isPredicting,
  customInputs,
  onSubmit,
}: Props) => {
  const handleSubmit = () => {
    onSubmit();
    onClose();
  };

  return (
    <Modal title="Affiner le chiffrage" onClose={onClose} opened={isOpen} size={"xl"}>
      <CustomInputsList
        customInputs={customInputs}
        quoteRequestLineId={quoteRequestLineId}
        isPredicting={isPredicting}
      />

      <Group justify="flex-end">
        <Button onClick={handleSubmit}>Ok</Button>
      </Group>
    </Modal>
  );
};
